import { RestSlice } from '../../../../redux/rest.slice';
import { FogPendingNotice } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const fogPendingNoticeSlice = new RestSlice<FogPendingNotice>(
	localizationService.getLocalizedString('notices.notices'),
	Resource.CccNotices
);
export const fogPendingNoticeReducer = fogPendingNoticeSlice.rests.reducer;
